'use client'

import { useSupabase } from '@/lib/utils/providers/supabase/supabase-provider'
import moment from 'moment'
import { useEffect, useState } from 'react'

export function useActiveCohort() {
  const [cohort, setCohort] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const { supabase } = useSupabase()

  useEffect(() => {
    const fetchActiveCohort = async () => {
      setIsLoading(true)
      try {
        const response = await supabase
          .from('cohort')
          .select('*')
          .order('created_at', { ascending: true })
          .eq('is_active', true)
          .single()

        const { deadline, start_date, end_date } = response?.data
        setCohort({
          deadline: moment(deadline).format('dddd Do MMMM (ha [GST])'),
          start_date: moment(start_date).format('dddd D MMMM'),
          end_date: moment(end_date).format('dddd D MMMM'),
        })
      } catch (error) {
        console.error('Failed to fetch cohort', error)
        setCohort(null)
      } finally {
        setIsLoading(false)
      }
    }

    fetchActiveCohort()
  }, [supabase])

  return { cohort, isLoading }
}
